export default __webpack_public_path__ + "static/media/SH-Master_Plan_Set-Low.0f6a3dda.pdf";